import React, { useState } from "react";
import sor from "../../../assets/images/fitbae/sor.jpg";
import { faqCode } from "../../../template_codes/fitbae/home_page_codes";
const FAQ = () => {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  return (
    <>
      <div className="mb-20">
        <div className="flex gap-4 mt-10 justify-center items-center">
          <button
            className={activeTab == 0 ? "border-b-2 " : ""}
            onClick={() => handleTabClick(0)}>
            Shipping
          </button>
          <button
            className={activeTab == 1 ? "border-b-2 " : ""}
            onClick={() => handleTabClick(1)}>
            Returns
          </button>
          <button
            className={activeTab == 2 ? "border-b-2 " : ""}
            onClick={() => handleTabClick(2)}>
            Laundry Care{" "}
          </button>
        </div>
        <div className=" mt-10 flex justify-center">
          <div className=" md:block hidden h-[500px] w-[500px]">
            {activeTab == 0 && (
              <img
                src={faqCode.shipping.image}
                className="h-[500px] w-[500px] bg-[#F8ECE4] object-cover"
                alt=""
              />
            )}
            {activeTab == 1 && (
              <img
                src={faqCode.returns.image}
                className="h-[500px] w-[500px] bg-[#F8ECE4] object-cover"
                alt=""
              />
            )}
            {activeTab == 2 && (
              <img
                src={faqCode.laundry_care.image}
                className="h-[500px] w-[500px] bg-[#F8ECE4] object-cover"
                alt=""
              />
            )}
          </div>
          {activeTab == 0 && (
            <div className="relative ">
              <div className="absolute w-[400px] h-[500px] -z-40 md:hidden ">
                <img
                  src={faqCode.shipping.image}
                  className=" w-[400px] h-[500px] object-cover"
                  alt=""
                />
              </div>
              <div className="md:w-[400px] lg:w-[500px] h-[500px] px-14  z-40 overflow-scroll md:overflow-hidden py-16 text-[14px] bg-[#F8ECE4a8]">
                <ul className="list-disc">
                  <li className="mb-4">
                    <span className="font-semibold"> Yangon Region :</span>{" "}
                    Standard Door-to-door Delivery (1- 5 days).
                  </li>
                  <li className="mb-4">
                    <span className="font-semibold">Other Regions :</span>{" "}
                    Door-to-door service and Bus station delivery service are
                    available. Your orders will be picked up from FIT.bae
                    warehouse in 1-3 day. Following that, we will provide you
                    the bus station receipt or door-to-door delivery receipt.
                  </li>
                  <li className="mb-4">
                    <span className="font-semibold">Pick-up :</span> Store
                    Pick-up system handles urgent deliveries only. Customer
                    needs to inform one day in advance for in-store pickup.
                  </li>
                </ul>
              </div>
            </div>
          )}
          {activeTab == 1 && (
            <div className="relative ">
              <div className="absolute w-[400px] h-[500px] md:hidden -z-40  ">
                <img
                  src={faqCode.returns.image}
                  className=" w-[400px] h-[500px] object-cover"
                  alt=""
                />
              </div>
              <div className="md:w-[400px] lg:w-[500px] h-[500px] px-14 overflow-scroll z-40  pt-16 pb-10 text-[14px] bg-[#F8ECE4a8]">
                <ul className="list-none">
                  <li className="mb-2">
                    <span className="font-semibold">1. Notification: </span>
                    Customers must inform us within 24 hours of receiving the
                    products for returns. Customers will be responsible for both
                    exchange and return delivery charges.
                  </li>
                  <li className="mb-2">
                    <span className="font-semibold">2. Eligibility: </span>
                    Worn, washed, or perfume-scented products are not eligible
                    for exchange or return. Products with animal or human hairs
                    will also not be accepted.
                  </li>

                  <li className="mb-2">
                    <span className="font-semibold">3. Non-Returnable: </span>
                    White and light color products cannot be returned or
                    exchanged.
                  </li>
                  <li className="mb-4">
                    <span className="font-semibold">4. Packaging: </span>
                    Exchanged items must be returned in their original undamaged
                    box with tags attached.
                  </li>
                  <li className="mb-4">
                    <span className="font-semibold">5. Exchange Policy: </span>
                    Only incorrect sizes and colors can be exchanged, subject to
                    meeting the exchange policy.
                  </li>
                  <li className="mb-4">
                    <span className="font-semibold">
                      6. Dispute Resolution:
                    </span>
                    The decision of the FIT.bae team is final in exchange policy
                    disputes.
                  </li>
                  <li className="mb-4">
                    <span className="font-semibold">
                      {" "}
                      7. Sale/Clearance Items:
                    </span>
                    Sale or clearance products are non-exchangeable.
                  </li>
                  <li className="mb-4">
                    <span className="font-semibold">8. Handling Fee: </span>
                    Multiple returns may incur a handling fee, communicated
                    prior to completion.
                  </li>
                </ul>
              </div>
            </div>
          )}
          {activeTab == 2 && (
            <div className="relative ">
              <div className="absolute w-[400px] h-[500px] md:hidden  -z-40">
                <img
                  src={faqCode.laundry_care.image}
                  className=" w-[400px] h-[500px] object-cover"
                  alt=""
                />
              </div>
              <div className="md:w-[400px] lg:w-[500px] h-[500px] px-14 overflow-scroll z-40 md:overflow-hidden py-16 text-[14px] bg-[#F8ECE4a8]">
                <ul className="list-none">
                  <li className="mb-4">
                    <p className="">
                      <span className="font-semibold">1. Sorting : </span>
                      Separate sportswears from other laundry items to prevent
                      color bleeding and potential damage.
                    </p>
                  </li>
                  <li className="mb-4">
                    <p className="">
                      <span className="font-semibold">2. Washing: </span>
                      Hand washing is preferred. For machine washing, use cold
                      water on a gentle cycle or use a specialized sportswear
                      setting. Do not soak in water for long period of time.
                    </p>
                  </li>

                  <li className="mb-4">
                    <p className="">
                      <span className="font-semibold">3. Detergent: </span>
                      Choose mild detergent for sportswear. Do not use
                      detergents containing bleach or fabric softener.
                    </p>
                  </li>
                  <li className="mb-4">
                    <p className="">
                      <span className="font-semibold">4. Drying: </span>
                      Air dry your sportswear by laying it flat or hanging it
                      up. If using a dryer, choose low heat to prevent
                      shrinking.
                    </p>
                  </li>
                  <li className="mb-4">
                    <p className="">
                      <span className="font-semibold">5. Ironing: </span>
                      Aviod ironing. However, if necessary, use a low heat
                      setting.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
      <hr className="mb-10" />
    </>
  );
};

export default FAQ;
